<div class="preview-page">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <div class="error-message">
      <h3>Oops! Something went wrong</h3>
      <p>{{ error }}</p>
      <button class="retry-button" (click)="retryPreviewLoad()">Try Again</button>
    </div>
  </div>

  <div *ngIf="!error && !isLoading && websiteElements.length === 0" class="error-container">
    <div class="error-message">
      <h3>Nothing to preview</h3>
      <p>
        This website has no page content yet. Open Preview from the website builder after the site
        has been saved.
      </p>
      <button class="retry-button" (click)="retryPreviewLoad()">Try Again</button>
    </div>
  </div>

  <!-- Template Preview - Minimal Theme -->
  <ng-container *ngIf="!error && !isLoading && websiteElements.length > 0 && isMinimalTemplate()">
    <!-- Home Page -->
    <app-home-page-preview
      *ngIf="currentPageType === 'home'"
      [elements]="websiteElements"
      [pageData]="getPreviewPageData()"
      [sectionVisibility]="sectionVisibility"
      [pages]="pages"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-home-page-preview>

    <!-- Express Wash Packages -->
    <app-express-wash-packages-preview
      *ngIf="currentPageType === 'express-wash-packages'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-express-wash-packages-preview>

    <!-- Express Auto Details -->
    <app-express-auto-details-preview
      *ngIf="currentPageType === 'express-auto-details'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-express-auto-details-preview>

    <!-- Fleet Management -->
    <app-fleet-management-preview
      *ngIf="currentPageType === 'fleet-management'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-fleet-management-preview>

    <!-- Coupons -->
    <app-coupons-preview
      *ngIf="currentPageType === 'coupons'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-coupons-preview>
  </ng-container>

  <!-- Template Preview - Modern Theme -->
  <ng-container *ngIf="!error && !isLoading && websiteElements.length > 0 && isModernTemplate()">
    <!-- Home Page -->
    <app-modern-home-page-preview
      *ngIf="currentPageType === 'home'"
      [elements]="websiteElements"
      [pageData]="getPreviewPageData()"
      [sectionVisibility]="sectionVisibility"
      [pages]="pages"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-modern-home-page-preview>

    <!-- Express Wash Packages -->
    <app-modern-express-wash-packages-preview
      *ngIf="currentPageType === 'express-wash-packages'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-modern-express-wash-packages-preview>

    <!-- Express Auto Details -->
    <app-modern-express-auto-details-preview
      *ngIf="currentPageType === 'express-auto-details'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-modern-express-auto-details-preview>

    <!-- Fleet Management -->
    <app-modern-fleet-management-preview
      *ngIf="currentPageType === 'fleet-management'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-modern-fleet-management-preview>

    <!-- Coupons -->
    <app-modern-coupons-preview
      *ngIf="currentPageType === 'coupons'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-modern-coupons-preview>
  </ng-container>

  <!-- Template Preview - Dark Theme -->
  <ng-container *ngIf="!error && !isLoading && websiteElements.length > 0 && isDarkTemplate()">
    <!-- Home Page -->
    <app-dark-home-page-preview
      *ngIf="currentPageType === 'home'"
      [elements]="websiteElements"
      [pageData]="getPreviewPageData()"
      [sectionVisibility]="sectionVisibility"
      [pages]="pages"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-dark-home-page-preview>

    <!-- Express Wash Packages -->
    <app-dark-express-wash-packages-preview
      *ngIf="currentPageType === 'express-wash-packages'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-dark-express-wash-packages-preview>

    <!-- Express Auto Details -->
    <app-dark-express-auto-details-preview
      *ngIf="currentPageType === 'express-auto-details'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-dark-express-auto-details-preview>

    <!-- Fleet Management -->
    <app-dark-fleet-management-preview
      *ngIf="currentPageType === 'fleet-management'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-dark-fleet-management-preview>

    <!-- Coupons -->
    <app-dark-coupons-preview
      *ngIf="currentPageType === 'coupons'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-dark-coupons-preview>
  </ng-container>

  <!-- Template Preview - Champs Theme -->
  <ng-container *ngIf="!error && !isLoading && websiteElements.length > 0 && isChampsTemplate()">
    <!-- Home Page -->
    <app-champs-home-page-preview
      *ngIf="currentPageType === 'home'"
      [elements]="websiteElements"
      [pageData]="getPreviewPageData()"
      [sectionVisibility]="sectionVisibility"
      [pages]="pages"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-champs-home-page-preview>

    <!-- Express Wash Packages -->
    <app-champs-express-wash-packages-preview
      *ngIf="currentPageType === 'express-wash-packages'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-champs-express-wash-packages-preview>

    <!-- Express Auto Details -->
    <app-champs-express-auto-details-preview
      *ngIf="currentPageType === 'express-auto-details'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-champs-express-auto-details-preview>

    <!-- Memberships -->
    <app-champs-memberships-preview
      *ngIf="currentPageType === 'memberships'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-champs-memberships-preview>

    <!-- Fleet Management -->
    <app-champs-fleet-management-preview
      *ngIf="currentPageType === 'fleet-management'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-champs-fleet-management-preview>

    <!-- Coupons -->
    <app-champs-coupons-preview
      *ngIf="currentPageType === 'coupons'"
      [pageData]="getPreviewPageData()"
      [pages]="pages"
      [currentPageType]="currentPageType"
      [sectionVisibility]="sectionVisibility"
      [elements]="websiteElements"
      [deviceType]="deviceType"
      [primaryColor]="primaryColor"
      [headingColor]="headingColor"
      [paragraphColor]="paragraphColor"
      [headingFont]="headingFont"
      [bodyFont]="bodyFont"
      (navigationClick)="onNavigationClick($event)"
      (elementSelect)="onElementSelect($event)"
    >
    </app-champs-coupons-preview>
  </ng-container>
</div>
